module.exports = __webpack_public_path__ + "media/images/mastercard copy-3b5739a2e315bdd3a711b20e0229085c.jpg";